
import { createApi } from "@reduxjs/toolkit/query/react";
import { announcementApi } from "../Constant";
import { encryptedBaseQueryWithReauth } from "../utilities/encryptedBaseQuery";

export const AnnouncementApi = createApi({
    reducerPath: "AnnouncementApi",
    baseQuery: encryptedBaseQueryWithReauth(process.env.REACT_APP_LOCAL_URL),
    endpoints: (builder) => ({

        getAnnouncementList: builder.query({
            query: (endpoint) => `${endpoint}`,
            providesTags: ["getAnnouncementList"],
        }),

        createAnnouncement: builder.mutation({
            query: ({ data }) => ({
                url: `${announcementApi.endPoint}/add`,
                method: "POST",
                body: data,

            }),
            invalidatesTags: [],
        }),
        updateAnnouncement: builder.mutation({
            query: ({ data, id }) => ({
                url: `${announcementApi.endPoint}/update/${id}`,
                method: "PATCH",
                body: data,

            }),
            invalidatesTags: [],
        }),
    }),
});

export const {
    useCreateAnnouncementMutation,
    useGetAnnouncementListQuery,
    useUpdateAnnouncementMutation,
    

} = AnnouncementApi;
